import { useEffect, useState } from 'react'
import { initMsal } from '../services/auth'
import { getPartnerCenterToken, getCustomers } from '../services/partnerCenter'
import { getGraphToken, getDelegatedAdminRelationships, getAccessAssignments, getSecurityGroupsWithMembers } from '../services/graphGdap'
import { mapCustomersWithGdap } from '../mappers/gdap'
import { mergeGroupsIntoCustomers } from '../utils/utils'

export const useGdap = () => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState()
  const [customers, setCustomers] = useState([])
  const [progress, setProgress] = useState({ percent: 0, phase: 'Idle' })

  useEffect(() => {
    initMsal()
  }, [])

  const signInAndLoad = async () => {
    setLoading(true)
    setError(undefined)
    try {
      setProgress({ percent: 10, phase: 'Acquiring Partner Center token' })
      const partnerToken = await getPartnerCenterToken()
      setProgress({ percent: 25, phase: 'Fetching customers' })
      const baseCustomers = await getCustomers(partnerToken)
      setProgress({ percent: 35, phase: 'Acquiring Microsoft Graph token' })
      const graphToken = await getGraphToken()
      setProgress({ percent: 55, phase: 'Fetching relationships' })
      const relationships = await getDelegatedAdminRelationships(graphToken)
      setProgress({ percent: 70, phase: 'Fetching access assignments' })
      const assignments = await getAccessAssignments(graphToken, relationships)
      setProgress({ percent: 80, phase: 'Mapping GDAP data' })
      const mapped = mapCustomersWithGdap(baseCustomers, relationships, assignments)
      // collect security group ids from assignments
      const groupIds = []
      mapped.forEach(c => {
        const assigns = Array.isArray(c.assignments) ? c.assignments : []
        assigns.forEach(assignment => {
          try {
            if (assignment.accessContainer?.accessContainerType === 'securityGroup') {
              const id = assignment.accessContainer?.accessContainerId
              if (id) groupIds.push(id)
            }
          } catch (_) {}
        })
      })
      setProgress({ percent: 90, phase: 'Fetching security groups' })
      const securityGroups = await getSecurityGroupsWithMembers(graphToken, groupIds)
      setProgress({ percent: 95, phase: 'Merging group details' })
      const merged = mergeGroupsIntoCustomers(mapped, securityGroups)
      setCustomers(merged)
      setProgress({ percent: 100, phase: 'Complete' })
    } catch (e) {
      console.error(e)
      setError(e)
      setProgress({ percent: 100, phase: 'Error' })
    } finally {
      setLoading(false)
    }
  }

  return { loading, error, customers, signInAndLoad, progress }
}

export default useGdap


